module.exports = __webpack_public_path__ + "media/images/static/top/urban/building_right-f575dc991e22b81c9360eb3b9aeba7ab.png";